module.exports = __webpack_public_path__ + "img/Z60_10.3d58b088.jpg";